exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navMenuContainer {\n    background: rgba(255, 255, 255, 0.3);\n    padding: 5px 0;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    text-align: center;\n    z-index: 30;\n}\n\n.menuItem {\n    display: inline-block;\n    margin-right: 20px;\n    padding: 6px 10px;\n    background-color: rgba(0, 0, 0, 0.3);\n    border-radius: 6px;\n}\n\n.menuItem:last-of-type {\n    margin-right: 0px;\n}\n\n.menuItem p{\n    margin-bottom: 0;\n}\n\n.menuItem a{\n  color: white;\n  text-decoration:none;\n  font-weight: 900;\n}\n\n.menuItem:hover{\n  background: rgba(119, 34, 32, 0.7);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/nav-bar/nav-bar.component.css
// module id = ../../../../../src/app/nav-bar/nav-bar.component.css
// module chunks = main